/* ticket-terms.js
   Event-terms consent for ticket carts. The checkout button stays locked until the terms are accepted, and the
   acceptance (with a timestamp) is written to the cart so it appears on the order as an additional detail. */
(function () {
  'use strict';
  if (window.__ttInit) return; window.__ttInit = true;
  var KEY = 'Ticket terms accepted', KEY_G = 'Ticket group terms accepted', KEY_V = 'Ticket terms version', KEY_U = 'Ticket terms page', KEY_S = 'SMS marketing consent', KEY_P = 'SMS consent phone', KEY_SV = 'SMS consent text version', saving = 0;

  function roots() { return Array.prototype.slice.call(document.querySelectorAll('[data-ticket-terms]')); }
  function cartScope(el) { return el.closest('cart-drawer, .cart, form, .cart__footer') || document; }
  function need(box) {
    var a = box.querySelector('[data-tt-agree]'), g = box.querySelector('[data-tt-group]'), grp = box.querySelector('[data-tt-grp]');
    var groupNeeded = grp && !grp.hidden;
    var sms = box.querySelector('[data-tt-sms]'), ph = box.querySelector('[data-tt-phone]');
    var smsBad = !!(sms && sms.checked) && digits(ph && ph.value).length < 10;
    var termsOk = !!(a && a.checked) && (!groupNeeded || !!(g && g.checked));
    return { ok: termsOk && !smsBad, termsOk: termsOk, smsBad: smsBad, a: a, g: g, groupNeeded: groupNeeded };
  }
  function buttons(box) {
    var scope = box.closest('cart-drawer') || document;
    return Array.prototype.slice.call(scope.querySelectorAll("button[name='checkout'], .cart__checkout-button"));
  }
  function apply() {
    var all = roots();
    document.body.classList.toggle('tt-locked', all.some(function (b) { return !need(b).ok || saving > 0; }));
    all.forEach(function (box) {
      var locked = !need(box).ok || saving > 0;
      buttons(box).forEach(function (btn) {
        btn.classList.toggle('tt-btn-locked', locked);
        if (locked) btn.setAttribute('aria-disabled', 'true'); else btn.removeAttribute('aria-disabled');
      });
    });
  }
  function save(box) {
    var n = need(box), now = new Date().toISOString(), attrs = {};
    attrs[KEY] = n.a && n.a.checked ? 'Yes (' + now + ')' : '';
    attrs[KEY_G] = n.groupNeeded && n.g && n.g.checked ? 'Yes (' + now + ')' : '';
    attrs[KEY_V] = n.a && n.a.checked ? (box.getAttribute('data-version') || '') : '';
    attrs[KEY_U] = n.a && n.a.checked ? (box.getAttribute('data-url') || '') : '';
    saving++; apply();
    fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ attributes: attrs }) })
      .catch(function () {})
      .then(function () { saving--; apply(); });
  }


  // Optional SMS marketing consent: never blocks checkout, saved only with a usable phone number.
  function digits(v) { return String(v || '').replace(/\D/g, ''); }
  // US numbers are saved as +1XXXXXXXXXX (what HubSpot and most SMS tools expect); numbers typed with a leading + are kept.
  function e164(v) {
    var raw = String(v || '').trim(), d = digits(raw);
    if (raw.charAt(0) === '+') return '+' + d;
    if (d.length === 10) return '+1' + d;
    if (d.length === 11 && d.charAt(0) === '1') return '+' + d;
    return '+' + d;
  }
  function saveSms(box) {
    var c = box.querySelector('[data-tt-sms]'), ph = box.querySelector('[data-tt-phone]'), hint = box.querySelector('[data-tt-phone-hint]'),
        wrap = box.querySelector('[data-tt-phone-wrap]'), attrs = {}, on = !!(c && c.checked), ok = on && digits(ph && ph.value).length >= 10;
    if (wrap) wrap.hidden = !on;
    if (hint) hint.hidden = !(on && !ok && ph && ph.value.length > 0);
    attrs[KEY_S] = ok ? 'Yes (' + new Date().toISOString() + ')' : '';
    attrs[KEY_P] = ok ? e164(ph.value) : '';
    attrs[KEY_SV] = ok ? '2026-10 v1' : '';
    fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ attributes: attrs }) }).catch(function () {});
  }
  var smsTimer = 0;
  function smsSync(box, src) {
    roots().forEach(function (o) {
      if (o === box) return;
      var c = o.querySelector('[data-tt-sms]'), p = o.querySelector('[data-tt-phone]'), w = o.querySelector('[data-tt-phone-wrap]');
      if (c) c.checked = box.querySelector('[data-tt-sms]').checked;
      if (p && src !== 'phone') p.value = box.querySelector('[data-tt-phone]').value;
      if (w) w.hidden = !box.querySelector('[data-tt-sms]').checked;
    });
  }
  document.addEventListener('change', function (e) {
    var box = e.target.closest && e.target.closest('[data-ticket-terms]');
    if (!box || !e.target.matches('[data-tt-sms]')) return;
    smsSync(box, 'check'); saveSms(box); apply();
  });
  document.addEventListener('input', function (e) {
    var box = e.target.closest && e.target.closest('[data-ticket-terms]');
    if (!box || !e.target.matches('[data-tt-phone]')) return;
    smsSync(box, 'phone'); apply(); clearTimeout(smsTimer); smsTimer = setTimeout(function () { saveSms(box); apply(); }, 700);
  });

  document.addEventListener('change', function (e) {
    var box = e.target.closest && e.target.closest('[data-ticket-terms]');
    if (!box || !e.target.matches('[data-tt-agree], [data-tt-group]')) return;
    var err = box.querySelector('[data-tt-err]'); if (err) err.hidden = true;
    var sel = e.target.matches('[data-tt-agree]') ? '[data-tt-agree]' : '[data-tt-group]';
    roots().forEach(function (other) {
      if (other === box) return;
      var c = other.querySelector(sel); if (c) c.checked = e.target.checked;
      var oe = other.querySelector('[data-tt-err]'); if (oe) oe.hidden = true;
    });
    save(box);
  });
  document.addEventListener('click', function (e) {
    var open = e.target.closest && e.target.closest('[data-tt-open]');
    if (open) { e.preventDefault(); var box = open.closest('[data-ticket-terms]'), d = box && box.querySelector('[data-tt-sum]'); if (d) { d.open = true; d.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); } return; }
    var btn = e.target.closest && e.target.closest("button[name='checkout'], .cart__checkout-button");
    if (!btn) return;
    var scope = btn.closest('cart-drawer') || document.getElementById('MainContent') || document, box2 = scope.querySelector('[data-ticket-terms]');
    if (!box2) return;
    if (!need(box2).ok || saving > 0) {
      e.preventDefault(); e.stopImmediatePropagation();
      var n2 = need(box2);
      if (!n2.ok) {
        var err = box2.querySelector('[data-tt-err]'), hint = box2.querySelector('[data-tt-phone-hint]'), ph2 = box2.querySelector('[data-tt-phone]');
        if (!n2.termsOk) { if (err) err.hidden = false; }
        else if (n2.smsBad && hint) { hint.textContent = 'Enter your mobile number to receive texts, or untick the text-message box to continue.'; hint.hidden = false; if (ph2) ph2.focus({ preventScroll: true }); }
        box2.classList.remove('tt--nudge'); void box2.offsetWidth; box2.classList.add('tt--nudge');
        box2.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }
    }
  }, true);
  document.addEventListener('submit', function (e) {
    var f = e.target, box = (f.closest && f.closest('cart-drawer')) ? f.closest('cart-drawer').querySelector('[data-ticket-terms]') : (document.getElementById('MainContent') || document).querySelector('[data-ticket-terms]');
    if (!box) return;
    var sub = e.submitter;
    if (sub && sub.name === 'checkout' && (!need(box).ok || saving > 0)) { e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);

  // a cart that no longer holds a ticket should not carry the acceptance
  function sweep() {
    if (document.querySelector('[data-tt-clear]') && !document.querySelector('[data-ticket-terms]')) {
      var a = {}; a[KEY] = ''; a[KEY_G] = ''; a[KEY_V] = ''; a[KEY_U] = ''; a[KEY_S] = ''; a[KEY_P] = ''; a[KEY_SV] = '';
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: a }) }).catch(function () {});
      document.querySelectorAll('[data-tt-clear]').forEach(function (n) { n.remove(); });
    }
    apply();
  }
  new MutationObserver(function () { sweep(); }).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', sweep);
  sweep();
})();
